import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface FilterHeaderElementEntryInterface {
    label: string;
    active: boolean;
    value?: number;
}
export interface FilterHeaderElementInterface {
    label: string;
    entrys: FilterHeaderElementEntryInterface[];
}

@Component({
    selector: 'app-custom-mat-menu',
    template: `
        <button app-button [matMenuTriggerFor]="menu">
            {{ Config.label }}
        </button>
        <mat-menu #menu="matMenu">
            <button
                mat-menu-item
                *ngFor="let element of Config.entrys"
                (click)="ClickHandler(element)"
            >
                {{ element.label }}
            </button>
        </mat-menu>
    `,
    styleUrls: ['./custom-mat-menu.component.scss'],
})
export class CustomMatMenuComponent {
    @Input() Config: FilterHeaderElementInterface;
    @Output() ElementClicked = new EventEmitter<
        FilterHeaderElementEntryInterface
    >(true);
    constructor() {}
    public ClickHandler(element: FilterHeaderElementEntryInterface) {
        this.ElementClicked.emit(element);
    }
}
